module.exports = __webpack_public_path__ + "static/media/ic_item_location.1c007b5f.svg";